"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlagiarismError = void 0;
var PlagiarismError;
(function (PlagiarismError) {
    PlagiarismError["UNSUPPORTED_FILETYPE"] = "UNSUPPORTED_FILETYPE";
    PlagiarismError["PROCESSING_ERROR"] = "PROCESSING_ERROR";
    PlagiarismError["CANNOT_EXTRACT_TEXT"] = "CANNOT_EXTRACT_TEXT";
    PlagiarismError["TOO_LITTLE_TEXT"] = "TOO_LITTLE_TEXT";
    PlagiarismError["TOO_MUCH_TEXT"] = "TOO_MUCH_TEXT";
    PlagiarismError["TOO_MANY_PAGES"] = "TOO_MANY_PAGES";
    PlagiarismError["FILE_LOCKED"] = "FILE_LOCKED";
    PlagiarismError["CORRUPT_FILE"] = "CORRUPT_FILE";
    PlagiarismError["UNKNOWN"] = "UNKNOWN";
})(PlagiarismError = exports.PlagiarismError || (exports.PlagiarismError = {}));
